import { setContext } from '@apollo/client/link/context';
import { getTenancy } from 'src/modules/debug/utils';
const addTenancyHeaderLink = setContext((_, context) => ({
    ...context,
    headers: {
        ...context.headers,
        'x-tenancy': getTenancy(),
    },
}));
export default addTenancyHeaderLink;
